import { Box, Typography } from '@mui/material';
import { useState } from "react";
import { Helmet } from 'react-helmet-async';
import MyPostedScams from "src/components/scam_section/MyPostedScams";
import PostScam from "src/components/scam_section/PostScam";
import SuggestedScams from "src/components/scam_section/SuggestedScams";

const ReportScam = () => {
  const [isViewMyReports, setIsViewMyReports] = useState(false)
  return (
    <Box
      sx={{
        padding: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        maxWidth: 800,
        margin: "auto",
      }}
    >
      <Helmet>
        <title>Report a Scam - Acadlance</title>
        <meta name="description" content="Report scams and fraudulent activities on Acadlance. View reported scams and protect yourself from scammers." />
      </Helmet>
      {/* post scam */}
      <PostScam setIsViewMyReports={setIsViewMyReports} isViewMyReports={isViewMyReports} />

      {isViewMyReports ? <MyPostedScams isViewMyReports={isViewMyReports} /> : <SuggestedScams />}

      <Typography variant="caption" sx={{ color: "#757575", textAlign: 'center' }}>
        Found yourself marked as a scammer by mistake? Contact{' '}
        <a href="mailto:enquiries@acadlance.com" style={{ color: '#6d4cb1', textDecoration: 'none', fontWeight: 'bold' }}>
          enquiries@acadlance.com
        </a>
      </Typography>

      {/* Pagination */}
      {/* <Typography
        variant="body2"
        sx={{ textAlign: "center", color: "#616161" }}
      >
        21 - 40 of 56 Reports
      </Typography> */}
    </Box>
  );
};

export default ReportScam;
